import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link, IfPermitted } from "components/common";
import { Alert, Col, Row } from "components/bootstrap";
import LicensesRoutes from "license/Routes";
const Status = () => {
  const { t } = useTranslation("enterprise_security");
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: t("events_license_status.title") }, /* @__PURE__ */ React.createElement("p", null, t("events_license_status.description")), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "licenses:create" }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "events_license_status.licenses_details",
      components: { licensesLink: /* @__PURE__ */ React.createElement(Link, { to: LicensesRoutes.LIST }) }
    }
  ))));
};
const EventsLicenseStatus = ({ licenseStatus: { status, missing }, summary = false }) => {
  if (!missing && status && status.valid) {
    return null;
  }
  if (summary) {
    return /* @__PURE__ */ React.createElement(Status, null);
  }
  return /* @__PURE__ */ React.createElement(Row, { className: "row-sm" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Status, null)));
};
export default EventsLicenseStatus;
